import React, { useEffect, useState } from "react";
import Sidebarmenu from "../../SideMenu/Sidemenu";
import TopHeader from "../../TopHeader/TopHeader";
import Offcanvas from "react-bootstrap/Offcanvas";
import loder from "../../../../img/loder3.gif";
import moment from "moment";
import {
  Page,
  Text,
  View,
  Document,
  StyleSheet,
  PDFDownloadLink,
  PDFViewer,
  Image,
  Font,
} from "@react-pdf/renderer";
import { useDispatch } from "react-redux";
import { toast } from "react-toastify";
import { testHistory } from "../../../../Helper/Redux/API";
import { Link } from "react-router-dom";

export default function Hearingtest() {
  const dispatch = useDispatch();
  const [addmenuopen, setAddMenuOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [gettest, setGetTest] = useState("");

  const gettestData = () => {
    setIsLoading(true); // Set loading to true when starting the data fetching

    dispatch(testHistory())
      .then((res) => {
        if (res?.payload?.status === true) {
          setGetTest(res?.payload?.data);
        } else {
          // Handle error if needed
          // toast.error(res?.payload?.message);
        }
      })
      .catch((error) => {
        console.error("Error fetching test data:", error);
        // Handle error if needed
      })
      .finally(() => {
        setIsLoading(false); // Set loading to false after data fetching completes
      });
  };

  useEffect(() => {
    gettestData();
  }, []);

  const user_Role = localStorage.getItem("UserName");
  return (
    <>
      <div className="container-fluid">
        <div className="table-responsive mt-4">
          <table className="table invoice_tabel">
            <thead>
              <tr>
                <th scope="col">#</th>
                <th scope="col">User Name</th>
                <th scope="col">Date&nbsp;&&nbsp;Time</th>
                <th scope="col">Test Status</th>
                <th scope="col">Report</th>
              </tr>
            </thead>
            <tbody>
              {isLoading ? (
                // Render a loader while data is being fetched
                <tr>
                  <td colSpan="5" style={{ textAlign: "center" }}>
                    <img src={loder} className="img-fluid" alt="loder" />
                  </td>
                </tr>
              ) : (
                // Render table rows if data is fetched
                Array.isArray(gettest) &&
                gettest.map((item, index) => (
                  <tr key={item?.id}>
                    <td>{index + 1}</td>
                    <td>{item?.user_name}</td>
                    <td>{item?.datetime}</td>
                    <td>{item.test_status ? "Yes" : "No"}</td>
                    <td>
                      <div className="myhistory_list">
                        <a
                          href={item.test_report}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          <i className="fa fa-eye" aria-hidden="true"></i>
                        </a>
                      </div>
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
      </div>
    </>
  );
}
